import { Controller } from "stimulus"
export default class extends Controller {
  static get targets(){
    return ['field'];
  }

  initialize(){
  }

   toggle(e){
     let disabled = e.target.checked
     this.fieldTarget.disabled = disabled;


    }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/field_lock_controller.js